// c:\Users\saoma\dev\house-planner\frontend\src\components\Sidebar.jsx
import React from "react";
import { v4 as uuidv4 } from 'uuid';
import { Input } from "@chakra-ui/react";

// 通常の部屋タイプ
const generalRoomTypes = [
  { name: "LDK", fill: "#d1eaff" },      // ライトブルー系
  { name: "洋室", fill: "#ffe4e1" },      // ピンク系
  { name: "和室", fill: "#e6f2c2" },      // グリーン系
  { name: "玄関", fill: "#f0e68c" },      // カーキ系
  { name: "ポーチ", fill: "#e0ffff" },    // ライトシアン系
  { name: "ホール", fill: "#fafad2" },    // ライトゴールデンロッドイエロー系
  { name: "トイレ", fill: "#d5e8d4" },    // ライトグリーン系
  { name: "洗面所", fill: "#add8e6" },  // ライトブルー (LDKより少し濃いめ)
  { name: "収納", fill: "#f5f5dc" },      // ベージュ系
  { name: "WIC", fill: "#fff0f5" },       // ラベンダーブラッシュ系 (ウォークインクローゼット)
  { name: "フリーサイズ", fill: "#cccccc", isFreeSize: true },  // カーキ系
];

// 浴室の定義 (固定値) - 指定された3種類を追加
const bathroomTypes = [
  { name: "浴室 1216サイズ", width: 100, height: 75, fill: "#c2dfff", image: "/images/bath_1216.png" },
  { name: "浴室 1616サイズ", width: 100, height: 100, fill: "#c2dfff", image: "/images/bath_1616.png" },
  { name: "浴室 1620サイズ", width: 125, height: 100, fill: "#c2dfff", image: "/images/bath_1620.png" },
];

// 階段の定義 (固定値)
const stairTypes = [
  { name: "階段 01-1F", width: 100, height: 50, fill: "#e0e0e0", image: "/images/stair01-1F.png" }, // 仮の画像パス
  { name: "階段 01-2F", width: 100, height: 100, fill: "#e0e0e0", image: "/images/stair01-2F.png" }, // 仮の画像パス
  { name: "階段 02-1F", width: 100, height: 50, fill: "#e0e0e0", image: "/images/stair02-1F.png" }, // 仮の画像パス
  { name: "階段 02-2F", width: 100, height: 100, fill: "#e0e0e0", image: "/images/stair02-2F.png" }, // 仮の画像パス
];

export default function Sidebar({
  onAddRoom,
  rooms, // roomsを受け取る
  selectedId, // selectedIdを受け取る
  onRotateRoom, // 回転ハンドラを受け取る
  updateSelectedRoom, // 選択された部屋を更新するハンドラを受け取る
}) {
  const [showStairOptions, setShowStairOptions] = React.useState(false);
  const [showBathroomOptions, setShowBathroomOptions] = React.useState(false);
  const [showGeneralRoomOptions, setShowGeneralRoomOptions] = React.useState(false); // 一般的な部屋のオプション表示用State
  const [showWallOptions, setShowWallOptions] = React.useState(false);

  const selectedRoom = rooms && selectedId ? rooms.find(room => room.id === selectedId) : null;

  const handleAddGeneralRoom = (roomType) => {
    onAddRoom(roomType);
    // setShowGeneralRoomOptions(false); // 一般的な部屋を追加しても、このカテゴリは閉じない
    setShowStairOptions(false); // 他のオプションも閉じる
    setShowBathroomOptions(false); // 他のオプションも閉じる
    setShowWallOptions(false); // 他のオプションも閉じる
  };

  const handleAddStair = (stairType) => {
    onAddRoom(stairType);
    setShowGeneralRoomOptions(false); // 他のオプションも閉じる
    //setShowStairOptions(false); // 階段を追加しても、このカテゴリは閉じない
    setShowBathroomOptions(false); // 他のオプションも閉じる
    setShowWallOptions(false); // 他のオプションも閉じる
  };

  // 浴室追加ハンドラ
  const handleAddBathroom = (bathroomType) => {
    onAddRoom(bathroomType);
    setShowGeneralRoomOptions(false); // 他のオプションも閉じる
    //setShowBathroomOptions(false); // 浴室を追加し手も、このカテゴリはを閉じない
    setShowStairOptions(false); // 他のオプションも閉じる
    setShowWallOptions(false); // 他のオプションも閉じる
  };

  // 壁追加ハンドラ
  const handleAddWall = (isHorizontal, isFreeSize, strokeWidth=8) => {
    const x = isHorizontal ? 100 : 100;
    const y = isHorizontal ? 100 : 100;
    const x2 = isHorizontal ? 200 : 100;
    const y2 = isHorizontal ? 100 : 200;
    onAddRoom({
      id: uuidv4(),
      name: "壁",
      type: "wall",
      x: x,
      y: y,
      x2: x2,
      y2: y2,
      strokeWidth: strokeWidth, // 線の太さ
      rotation: 0,
      isFreeSize: isFreeSize,
    });
    setShowGeneralRoomOptions(false);
    setShowStairOptions(false);
    setShowBathroomOptions(false);
  };

  return (
    <div style={{ padding: 16, width: 150 }}>
        <>
          <h4 style={{ marginTop: 0, marginBottom: 8 }}>部屋を追加</h4>
          {/* 一般的な部屋選択ボタン */}
          <button
            onClick={() => {
              setShowGeneralRoomOptions(!showGeneralRoomOptions);
              setShowBathroomOptions(false); // 他のオプションは閉じる
              setShowStairOptions(false);   // 他のオプションは閉じる
              setShowWallOptions(false);   // 他のオプションは閉じる
            }}
            style={{ display: "block", marginBottom: 8, width: "100%" }}
          >
            部屋 {showGeneralRoomOptions ? "▼" : "▶"}
          </button>
          {/* 一般的な部屋の選択肢 (showGeneralRoomOptionsがtrueの場合に表示) */}
          {showGeneralRoomOptions && (
            <div style={{ marginLeft: 10, borderLeft: "2px solid #eee", paddingLeft: 10, marginBottom: 8 }}>
              {generalRoomTypes.map((room) => (
                <button
                  key={room.name}
                  onClick={() => handleAddGeneralRoom(room)}
                  style={{ display: "block", marginBottom: 4, width: "100%", fontSize: "0.9em" }}
                >
                  {room.name}
                </button>
              ))}
            </div>
          )}
          {/* 浴室選択ボタン */}
          <button
            onClick={() => {
              setShowBathroomOptions(!showBathroomOptions);
              setShowGeneralRoomOptions(false); // 他のオプションは閉じる
              setShowStairOptions(false);     // 他のオプションは閉じる
              setShowWallOptions(false);     // 他のオプションは閉じる
            }}
            style={{ display: "block", marginBottom: 8, width: "100%" }}
          >
            浴室 {showBathroomOptions ? "▼" : "▶"}
          </button>
          {/* 浴室の選択肢 (showBathroomOptionsがtrueの場合に表示) */}
          {showBathroomOptions && (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginLeft: 10, borderLeft: "2px solid #eee", paddingLeft: 10, marginBottom: 8 }}>
              {bathroomTypes.map((bathroom) => (
                <div key={bathroom.name} style={{ marginBottom: 8, textAlign: "center" }}>
                  <img
                    src={bathroom.image}
                    alt={bathroom.name}
                    onClick={() => handleAddBathroom(bathroom)}
                    style={{
                      width: "100px", // 画像の表示幅
                      height: "auto",  // 高さは自動調整
                      cursor: "pointer",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      padding: "2px", // 画像の周りに少し余白
                    }}
                  />
                  <div style={{ fontSize: "0.8em", marginTop: "2px" }}>{bathroom.name.replace("浴室 ", "")}</div>
                </div>
              ))}
            </div>
          )}
          {/* 階段選択ボタン */}
          <button
            onClick={() => {
              setShowStairOptions(!showStairOptions);
              setShowGeneralRoomOptions(false); // 他のオプションは閉じる
              setShowBathroomOptions(false);  // 他のオプションは閉じる
              setShowWallOptions(false);     // 他のオプションは閉じる
            }}
            style={{ display: "block", marginBottom: 8, width: "100%" }}
          >
            階段 {showStairOptions ? "▼" : "▶"}
          </button>
          {/* 階段の選択肢 (showStairOptionsがtrueの場合に表示) */}
          {showStairOptions && (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginLeft: 10, borderLeft: "2px solid #eee", paddingLeft: 10, marginBottom: 8 }}>
              {stairTypes.map((stair) => (
                <div key={stair.name} style={{ marginBottom: 8, textAlign: "center" }}>
                  <img
                    src={stair.image}
                    alt={stair.name}
                    onClick={() => handleAddStair(stair)}
                    style={{
                      width: "100px", // 画像の表示幅 (浴室と同様に設定)
                      height: "auto",  // 高さは自動調整
                      cursor: "pointer",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      padding: "2px",
                    }}
                  />
                  <div style={{ fontSize: "0.8em", marginTop: "2px" }}>{stair.name.replace("階段 ", "").replace("(", "").replace(")", "")}</div> {/* 表示名を調整 */}
                </div>
              ))}
            </div>
          )}
          {/* 壁選択ボタン */}
          <button
            onClick={() => {
              setShowWallOptions(!showWallOptions);
              setShowGeneralRoomOptions(false);
              setShowBathroomOptions(false);
              setShowStairOptions(false);
            }}
            style={{ display: "block", marginBottom: 8, width: "100%" }}
          >
            壁・線 {showWallOptions ? "▼" : "▶"}
          </button>
          {/* 壁の選択肢 (showWallOptionsがtrueの場合に表示) */}
          {showWallOptions && (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginLeft: 10, borderLeft: "2px solid #eee", paddingLeft: 10, marginBottom: 8 }}>
              <button
                onClick={() => handleAddWall(true, false, 8)}
                style={{ display: "block", marginBottom: 4, width: "100%", fontSize: "0.9em" }}
              >
                壁(水平)
              </button>
              <button
                onClick={() => handleAddWall(false, false, 8)}
                style={{ display: "block", marginBottom: 4, width: "100%", fontSize: "0.9em" }}
              >
                壁(垂直)
              </button>
              <button
                onClick={() => handleAddWall(true, true, 8)}
                style={{ display: "block", marginBottom: 4, width: "100%", fontSize: "0.9em" }}
              >
                水平線(太)
              </button>
              <button
                onClick={() => handleAddWall(false, true, 8)}
                style={{ display: "block", marginBottom: 4, width: "100%", fontSize: "0.9em" }}
              >
                垂直線(太)
              </button>
              <button
                onClick={() => handleAddWall(true, true, 2)}
                style={{ display: "block", marginBottom: 4, width: "100%", fontSize: "0.9em" }}
              >
                水平線(細)
              </button>
              <button
                onClick={() => handleAddWall(false, true, 2)}
                style={{ display: "block", marginBottom: 4, width: "100%", fontSize: "0.9em" }}
              >
                垂直線(細)
              </button>
            </div>
          )}

          {/* 選択された部屋が階段または浴室の場合に回転ボタンを表示 */}
          {selectedRoom && (selectedRoom.name?.startsWith("階段") || selectedRoom.name?.startsWith("浴室")) && (
            <div style={{ marginTop: 16, borderTop: "1px solid #eee", paddingTop: 8 }}>
              <h5 style={{ marginTop: 0, marginBottom: 8 }}>操作</h5>
              <button
                onClick={() => onRotateRoom(selectedId, -90)}
                style={{ display: "block", marginBottom: 4, width: "100%", fontSize: "0.9em" }}
              >
                ↺ 左回転
              </button>
              <button
                onClick={() => onRotateRoom(selectedId, 90)}
                style={{ display: "block", marginBottom: 4, width: "100%", fontSize: "0.9em" }}
              >
                ↻ 右回転
              </button>
            </div>
          )}
          {selectedRoom && selectedRoom.type === "room" && !(selectedRoom.name?.startsWith("浴室") || selectedRoom.name?.startsWith("階段")) && (
            <div style={{ backgroundColor: "white", padding: 5, borderRadius: 5 }}>
              <div>名前を変更</div>
              <Input type="string" onChange={(e) => {
                console.log(e.target.value);
                selectedRoom.name = e.target.value;
                updateSelectedRoom(selectedRoom);
              }} />
            </div>
          )}

        </>
    </div>
  );
}
